import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reducers from "./reducers";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { legacy_createStore as createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { register } from "./serviceWorkerRegistration";
const middlewares = [thunk];
const store = createStore(reducers, applyMiddleware(...middlewares));
const root = ReactDOM.createRoot(document.getElementById("root"));
register();

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {})
      .catch((err) => {
        console.error("Service worker registration failed:", err);
      });
  });
}
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
);
